const normalizeRoleValue = (value) => (
  value == null
    ? ''
    : value.toString().trim().toLowerCase().replace(/[\s-]+/g, '_')
);

const DOCTOR_ROLE_VALUES = new Set([
  'doctor',
  'doctors',
  'physician',
  '\u0637\u0628\u064a\u0628',
  '\u0627\u0644\u0637\u0628\u064a\u0628',
]);

const getRoleValues = (role) => {
  if (role == null) return [];
  if (typeof role !== 'object') return [role];

  return [
    role.name,
    role.slug,
    role.code,
    role.key,
    role.type,
    role.value,
    role.role,
  ];
};

const isDoctorRoleValue = (value) => DOCTOR_ROLE_VALUES.has(normalizeRoleValue(value));

export const isDoctorAccount = (user) => {
  if (!user) return false;

  const directRoleValues = [
    user.user_type,
    user.partner_type,
    ...getRoleValues(user.role),
    ...getRoleValues(user.type),
    user.account_type,
    user.accountType,
    user.userType,
    user.profile_type,
  ];

  if (directRoleValues.some(isDoctorRoleValue)) {
    return true;
  }

  const roleValues = Array.isArray(user.roles) ? user.roles.flatMap(getRoleValues) : [];
  if (roleValues.some(isDoctorRoleValue)) {
    return true;
  }

  return Boolean(user.doctor_id || user.doctor?.id || user.doctor_profile?.id);
};
